import React, { Component, Fragment } from "react";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router";
import CartList from "./CartList";
import UserList from "./selectLists/UserList";
import GoodsList from "./selectLists/GoodsList";
import SelectDetail from "./selectLists/SelectDetail";

import CartListNoUser from "./CartListNoUser";
import GoodsListNoUser from "./selectLists/GoodsListNoUser";
import SelectDetailNoUser from "./selectLists/SelectDetailNoUser";
import "./OrderContainer.scss";

@inject("commonStore", "orderStore")
@observer
class OrderContainer extends Component {
  state = {
    selectUser: null,
    selectGoods: null,
  };

  UNSAFE_componentWillMount() {
    this.props.orderStore.setCommonStoreInfo(this.props.commonStore);
    this.props.orderStore.onClear();
    // this.props.orderStore.orderUserList();
    // this.props.orderStore.disCartList();

    // 센터 셀렉트박스 리스트
    const { sessionLoginInfo } = this.props.commonStore;
    if (sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_SAMSUNG) {
      if (
        sessionLoginInfo !== undefined &&
        sessionLoginInfo !== null &&
        sessionLoginInfo.ceBranchCd !== undefined &&
        sessionLoginInfo.ceBranchCd !== null
      ) {
        this.props.orderStore.disCenterList(sessionLoginInfo.ceBranchCd);
      }
    }
    // if (sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_LGLOG) {
    //   if (sessionLoginInfo !== undefined && sessionLoginInfo !== null
    //     && sessionLoginInfo.deviceType !== undefined && sessionLoginInfo.deviceType !== null) {

    //   }
    // }
  }

  render() {
    const { sessionLoginInfo } = this.props.commonStore;
    const { selectUser, selectGoods } = this.state;
    //console.log('fsdfsdf  \n\n\n\n\n '  +   sessionLoginInfo.deviceType    );
    return (
      <Fragment>
        <div
          style={{ width: "100%", marginBottom: "10px", minHeight: "660px" }}
        >
          {sessionLoginInfo !== null &&
          sessionLoginInfo.ceType !== undefined &&
          sessionLoginInfo.ceType !== null &&
          sessionLoginInfo.cGbn ===
            process.env.REACT_APP_TYPE_COMPANY_SAMSUNG ? (
            <Fragment>
              <div className="table_ord_step01">
                <UserList
                  ceType={
                    sessionLoginInfo !== null &&
                    sessionLoginInfo.ceType !== undefined &&
                    sessionLoginInfo.ceType !== null
                      ? sessionLoginInfo.ceType
                      : ""
                  }
                  selectUser={selectUser}
                  onSelect={(data) =>
                    this.setState({ selectUser: data, selectGoods: null })
                  }
                />
              </div>
              <div className="table_ord_step02">
                <GoodsList
                  selectUser={selectUser}
                  detailGoods={selectGoods}
                  onSelect={(data) => this.setState({ selectGoods: data })}
                />
              </div>
              <div className="table_ord_step03">
                <SelectDetail
                  detailUser={selectUser}
                  detailGoods={selectGoods}
                  onSelect={() => {
                    this.setState({ selectGoods: null });
                  }}
                />
              </div>
            </Fragment>
          ) : sessionLoginInfo !== null &&
            sessionLoginInfo.ceType !== undefined &&
            sessionLoginInfo.ceType !== null &&
            sessionLoginInfo.cGbn ===
              process.env.REACT_APP_TYPE_COMPANY_LGLOG &&
            sessionLoginInfo.deviceType === "Web" ? (
            <Fragment>
              <div className="table_ord_step04">
                <GoodsListNoUser
                  detailGoods={selectGoods}
                  onSelect={(data) => this.setState({ selectGoods: data })}
                />
              </div>
              <div className="table_ord_step03">
                <SelectDetailNoUser
                  detailGoods={selectGoods}
                  onSelect={() => this.setState({ selectGoods: null })}
                />
              </div>
            </Fragment>
          ) : (
            <Fragment>
              <div className="table_ord_step06">
                <GoodsListNoUser
                  detailGoods={selectGoods}
                  onSelect={(data) => this.setState({ selectGoods: data })}
                />
              </div>
              <div className="table_ord_step03">
                <SelectDetailNoUser
                  detailGoods={selectGoods}
                  onSelect={() => this.setState({ selectGoods: null })}
                />
              </div>
            </Fragment>
          )}
        </div>
        {sessionLoginInfo !== null &&
        sessionLoginInfo.ceType !== undefined &&
        sessionLoginInfo.ceType !== null &&
        sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_LGLOG ? (
          <CartListNoUser
            ceType={
              sessionLoginInfo !== null &&
              sessionLoginInfo.ceType !== undefined &&
              sessionLoginInfo.ceType !== null
                ? sessionLoginInfo.ceType
                : ""
            }
          />
        ) : (
          <CartList
            ceType={
              sessionLoginInfo !== null &&
              sessionLoginInfo.ceType !== undefined &&
              sessionLoginInfo.ceType !== null
                ? sessionLoginInfo.ceType
                : ""
            }
          />
        )}
      </Fragment>
    );
  }
}

export default withRouter(OrderContainer);
